import { usePlanMealConditions as useMealConditions } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/meal-conditions/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanMealConditions = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { includedMeals } = viewModel;

	return useMealConditions({
		includedMeals,
		onSetViewModel,
	});
};
